import { render, staticRenderFns } from "./ManageDataBuildContactAllocation.vue?vue&type=template&id=0af673b4&scoped=true"
import script from "./ManageDataBuildContactAllocation.vue?vue&type=script&lang=js"
export * from "./ManageDataBuildContactAllocation.vue?vue&type=script&lang=js"
import style0 from "./ManageDataBuildContactAllocation.vue?vue&type=style&index=0&id=0af673b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af673b4",
  null
  
)

export default component.exports